import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

export class ModalDialog extends React.Component {
  onEntered = () => this.title.focus();

  setTitle = (h1) => {
    this.title = h1;
  };

  removeDocumentRole() {
    const element = document.getElementsByClassName('modal-content')[0];
    element.removeAttribute('role');
  }

  renderButtonDescriptionText(message, id) {
    return (message ?
      <span className="sr-only" id={id}>
        <FormattedMessage { ...message } />
      </span> : null);
  }

  render() {
    let submitBtnStyle;
    let hideBtnStyle;
    const titleId = 'modal-title-' + this.props.id;
    const bodyTextId = 'modal-text-' + this.props.id;
    const submitButtonId = 'modal-submit-' + this.props.id;
    const hideButtonId = 'modal-hide-' + this.props.id;

    if (this.props.isSubmitBtnHighlighted ||
      this.props.isSubmitBtnHighlighted === undefined ||
        this.props.isSubmitBtnHighlighted === null) {
      submitBtnStyle = 'btn btn-primary';
      hideBtnStyle = 'btn btn-outline-secondary';
    } else {
      submitBtnStyle = 'btn btn-outline-secondary';
      hideBtnStyle = 'btn btn-primary';
    }

    return (
      <div className="static-modal">
        <Modal show={this.props.show} onHide={this.props.onHide}
          onEntering={this.removeDocumentRole} aria-labelledby="modalTitle"
          aria-describedby="modalBodyText"
        >
          <Modal.Header closeButton>
            <Modal.Title className="h5" data-qa-item={titleId}>
              <div id="modalTitle">
                <FormattedMessage { ...this.props.title } />
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="modal-body-text" data-qa-item={ bodyTextId } id="modalBodyText">
              <p className="mb-3"><FormattedMessage { ...this.props.message } /></p>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              className={submitBtnStyle}
              onClick={this.props.onSubmit}
              data-qa-item={ submitButtonId }
              aria-describedby="labelDesc_submit"
              tabIndex="0"
            >
              <FormattedMessage { ...this.props.submitBtnText } />
            </button>
            <button
              className={hideBtnStyle}
              onClick={this.props.onHide}
              data-qa-item={ hideButtonId }
              aria-describedby="labelDesc_hide"
              tabIndex="0"
            >
              <FormattedMessage { ...this.props.hideBtnText } />
            </button>
          </Modal.Footer>
        </Modal>
        { this.renderButtonDescriptionText(this.props.hideBtnTextDescription, 'labelDesc_hide') }
        { this.renderButtonDescriptionText(this.props.submitBtnTextDescription, 'labelDesc_submit') }
      </div>
    );
  }
}

ModalDialog.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.object,
  message: PropTypes.object, // array of items to stuff into the message. ['Hi',<div>html</div>,"newrow"]
  submitBtnText: PropTypes.object.isRequired,
  submitBtnTextDescription: PropTypes.object,
  hideBtnText: PropTypes.object.isRequired,
  hideBtnTextDescription: PropTypes.object,
  isSubmitBtnHighlighted: PropTypes.bool,
  onSubmit: PropTypes.func,
  onHide: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
